import React, { useCallback } from 'react';
import c from 'classnames';

import { BaseButton } from '../../../Buttons';
import Typography from '../../../Typography';
import { NumberRatingItemProps } from './types';

const classes = {
  notSelected: 'text-text-primary border-divider bg-bg-secondary hover:bg-bg-tertiary',
  root: 'box-border w-44 h-44 border border-solid cursor-pointer rounded-full',
  selected:
    'text-text-white bg-interactive-primary border-interactive-primary hover:bg-interactive-primary',
};

const NumberRatingItem = (props: NumberRatingItemProps) => {
  const { className, onChange, selected, value } = props;
  const onClick = useCallback(() => onChange(value), [onChange, value]);
  return (
    <BaseButton
      className={c(
        'flex flex-row items-center justify-center p-0 min-w-0',
        classes.root,
        selected ? classes.selected : classes.notSelected,
        className,
      )}
      onClick={onClick}
      onLayout={props?.onLayout}>
      <Typography
        color={selected ? 'text-text-white' : 'text-text-primary'}
        variant="body-short-02">
        {value}
      </Typography>
    </BaseButton>
  );
};

export default React.memo(NumberRatingItem);
